import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'



const myCustomLightTheme = {
    dark: false,
    colors: {
        background: '#F6F6F6',
        surface: '#FFFFFF',
        primary: '#92C400',
        secondary: '#F8FFE2',
        accent: '#E9F3F2',
        error: '#b71c1c',
        info: '#6E8E4BCC',
        success: '#4CAF50',
        warning: '#FB8C00',
    },
}

export default createVuetify({
    components,
    directives,
    theme: {
        defaultTheme: 'myCustomLightTheme',
        themes: {
            myCustomLightTheme,
            icons: {
                defaultSet: 'mdi', // This is already the default value - only for display purposes
            },
        },
    },
})